<template>
  <div>
    <validation-observer ref="obCanBo">
      <b-form>
        <b-row>
          <b-col cols="10">
            <ValidationProvider
              name="Tên đơn vị tiếng Việt"
              rules="required"
              v-slot="validationContext"
            >
              <b-form-group
                label="Tên đơn vị tiếng Việt"
                label-align-sm="right"
                label-class="required"
                label-cols-sm="3"
                label-for="hoTen"
              >
                <b-form-input
                  :disabled="onlyView"
                  :state="getValidationState(validationContext)"
                  id="hoTen"
                  v-model="form.tenDonVi"
                ></b-form-input>
                <b-form-invalid-feedback
                  >{{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </ValidationProvider>
            <b-form-group
              label="Mã đơn vị"
              label-align-sm="right"
              label-cols-sm="3"
              label-for="maDonVi"
            >
              <b-form-input
                :disabled="onlyView"
                id="maDonVi"
                v-model="form.maDonVi"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              label="Đơn vị cha"
              label-align-sm="right"
              label-cols-sm="3"
              label-for="donVi"
            >
              <treeselect
                :disabled="onlyView"
                :key="reloadDonVI"
                :load-options="loadOptionsDonVi"
                :normalizer="normalizer"
                :options="optionsDonVi"
                :show-count="true"
                :value="form.iD_DonVi_Cha"
                no-children-text="Không có đơn vị con"
                placeholder="Chọn đơn vị"
                ref="chonCayDonVi"
                v-model="form.iD_DonVi_Cha"
              >
                <label
                  :class="labelClassName"
                  slot="option-label"
                  slot-scope="{
                    node,
                    shouldShowCount,
                    count,
                    labelClassName,
                    countClassName,
                  }"
                >
                  {{ node.label }}
                  <span
                    :class="countClassName"
                    v-if="shouldShowCount && count > 0"
                    >({{ count }})</span
                  >
                </label>
              </treeselect>
            </b-form-group>
            <b-form-group
              label="Mã liên thông"
              label-align-sm="right"
              label-cols-sm="3"
              label-for="maLienThong"
            >
              <b-form-input
                :disabled="onlyView"
                id="maLienThong"
                v-model="form.maLienThong"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              label="Thứ tự"
              label-align-sm="right"
              label-cols-sm="3"
              label-for="thuTu"
            >
              <b-form-input
                :disabled="onlyView"
                id="thuTu"
                v-model="form.thuTu"
              ></b-form-input>
            </b-form-group>
            <ValidationProvider
              name="Số điện thoại"
              rules="phone_number:8,20"
              v-slot="validationContext"
            >
              <b-form-group
                label="Số điện thoại"
                label-align-sm="right"
                label-cols-sm="3"
                label-for="soDienThoai"
              >
                <b-form-input
                  :disabled="onlyView"
                  :state="getValidationState(validationContext)"
                  id="soDienThoai"
                  v-model="form.soDienThoai"
                ></b-form-input>
                <b-form-invalid-feedback
                  >{{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </ValidationProvider>
            <ValidationProvider
              name="Email"
              rules="email"
              v-slot="validationContext"
            >
              <b-form-group
                label="Email"
                label-align-sm="right"
                label-cols-sm="3"
                label-for="email"
              >
                <b-form-input
                  :disabled="onlyView"
                  :state="getValidationState(validationContext)"
                  id="email"
                  v-model="form.email"
                ></b-form-input>
                <b-form-invalid-feedback
                  >{{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </ValidationProvider>
            <b-form-group
              label="Fax"
              label-align-sm="right"
              label-cols-sm="3"
              label-for="fax"
            >
              <b-form-input
                :disabled="onlyView"
                id="fax"
                v-model="form.fax"
              ></b-form-input>
            </b-form-group>

            <b-form-group label-align-sm="right" label-cols-sm="3">
              <div class="mt-sm-2">
                <b-form-checkbox
                  :disabled="onlyView"
                  id="bit_DonViBoPhan"
                  inline
                  v-model="form.bit_DonViBoPhan"
                  >Đơn vị bộ phận
                </b-form-checkbox>
                <b-form-checkbox
                  :disabled="onlyView"
                  id="bit_NhanTinBuon_Email"
                  inline
                  v-model="form.bit_LanhDao"
                  >Thuộc ban lãnh đạo
                </b-form-checkbox>
              </div>
            </b-form-group>
            <b-form-group label-cols-sm="3">
              <div class="mt-sm-2">
                <b-form-checkbox
                  :disabled="onlyView"
                  id="bit_DonViThuocBo"
                  inline
                  v-model="form.bit_DonViThuocBo"
                >
                  Trực thuộc bộ KHDT
                </b-form-checkbox>
                <b-form-checkbox
                  :disabled="onlyView"
                  id="bit_DonViSuNghiep"
                  inline
                  v-model="form.bit_DonViSuNghiep"
                  >Đơn vị sự nghiệp
                </b-form-checkbox>
              </div>
            </b-form-group>
          </b-col>
        </b-row>
        <div class="w-100 center mb-3 mt-5">
          <base-button @click="backToList()" class="btn btn-line">
            {{ onlyView ? "Đóng" : HUY_BO_BUTTON_LABEL }}
          </base-button>
          <base-button
            @click="onSubmit()"
            :disabled="isLoading"
            :button="isEdit ? 'Cập nhật' : 'Thêm Mới'"
            v-if="!onlyView"
          />
          <base-button
            button="Đi tới chỉnh sửa"
            @click="goEdit()"
            class="btn btn-main ml-2"
            v-else
          >
            Đi tới chỉnh sửa
          </base-button>
        </div>
      </b-form>
    </validation-observer>
    <b-tabs content-class="mt-3" v-if="isEdit">
      <b-tab
        :active="activeTab === 1"
        @click="changeCurrentTab(1)"
        title="Đơn vị con"
      >
        <div class="box box-form">
          <b-row align-h="end" class="pb-3">
            <b-col align-self="end" cols="auto">
              <base-button button="Thêm mới" @click="themDonVi" />
            </b-col>
          </b-row>
          <table class="table b-table table-striped table-bordered">
            <caption>Caption</caption>
            <thead class="center">
              <tr>
                <th scope="col">STT</th>
                <th scope="col">Tên đơn vị</th>
                <th scope="col">Thao tác</th>
              </tr>
            </thead>
            <draggable
              @change="capNhatThuTuNhomChucVu"
              @end="drag = false"
              @start="drag = true"
              element="tbody"
              handle=".handle"
              v-model="items"
            >
              <tr
                :key="item.name"
                class="draggable"
                role="row"
                v-for="(item, index) in items"
              >
                <td class="center fit-column" role="cell">{{ index + 1 }}</td>
                <td role="cell">{{ item.tenDonVi }}</td>
                <td class="fit-column" role="cell">
                  <div class="text-center">
                    <b-button class="handle" variant="link">
                      <b-icon
                        :style="{
                          color: '#2A6EBB',
                          cursor: 'move',
                          marginLeft: '5px',
                        }"
                        icon="justify"
                        title="Thay đổi thứ tự"
                      />
                    </b-button>
                    <b-button @click="openEdit(item)" variant="link">
                      <b-icon
                        :style="{
                          color: '#2A6EBB',
                          cursor: 'pointer',
                          marginLeft: '5px',
                        }"
                        icon="pencil-square"
                        title="Cập nhật"
                      />
                    </b-button>
                    <b-button @click="openDelete(item)" variant="link">
                      <b-icon
                        :style="{
                          color: '#2A6EBB',
                          cursor: 'pointer',
                          marginLeft: '5px',
                        }"
                        icon="trash"
                        title="Xóa nhóm"
                      />
                    </b-button>
                  </div>
                </td>
              </tr>
            </draggable>
          </table>
        </div>
      </b-tab>
      <b-tab
        :active="activeTab === 2"
        @click="changeCurrentTab(2)"
        title="Cán bộ trực thuộc"
      >
        <div class="box box-form">
          <DanhSachCanBo :idDonViCha="isEdit" />
        </div>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
import { HUY_BO_BUTTON_LABEL, ROUTE_NAME } from "@/constants/constants";
import { LOAD_CHILDREN_OPTIONS, Treeselect } from "@riophae/vue-treeselect";
import { objectTrim } from "@/utils/convertData";
import DanhSachCanBo from "@/components/pages/quan-ly-danh-muc/can-bo/DanhSachCanBo";
import draggable from "vuedraggable";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

export default {
  name: "TaoCanBo",
  components: {
    Treeselect,
    draggable,
    DanhSachCanBo,
  },
  data() {
    return {
      ROUTE: ROUTE_NAME,
      HUY_BO_BUTTON_LABEL: HUY_BO_BUTTON_LABEL,
      activeTab: 1,
      items: [],
      donViDaChon: null,
      reloadDonVI: false,
      isLoading: false,
      form: {
        tenDonVi: "",
        iD_DonVi_Cha: this.$route.query.idDonViCha || null,
        iD_DonVi_Goc: null,
        maDonVi: "",
        capDonVi: 0,
        duongDan_ID_DonVi_Cha: "",
        duongDan_ID_DonVi: "",
        maLienThong: "",
        bit_DonViBoPhan: false,
        thuTu: 0,
        bit_LanhDao: false,
        soDienThoai: "",
        email: "",
        fax: "",
        bit_DonViThuocBo: false,
        bit_DonViSuNghiep: false,
      },
      optionsGender: [
        { label: "Nữ", value: true },
        { label: "Nam", value: false },
      ],
      optionsDonVi: [],
      listDonViCon: [],
      isEdit: this.$route.query.id,
      idDonViCha: this.$route.query.idDonViCha,
      onlyView: this.$route.query.onlyview,
    };
  },
  computed: {
    ...mapGetters({
      chiTietCanBo: "canBo/canBo",
      danhSachDonVi: "donVi/danhSachDonVi",
      danhSachChucVu: "chucVu/danhSachChucVu",
      dsDonViCon: "donVi/danhSachDonViCon",
      danhSachDonViCon: "donVi/danhSachDonViCon",
      danhSachDonViPhanTrang: "donVi/danhSachDonViPhanTrang",
    }),
  },
  async created() {
    this.layDanhSachChucVu();
    this.$store.dispatch("donVi/layDanhSachDonVi", {});
    if (this.isEdit) {
      await this.layChiTietDonVi();
      await this.layDanhSachDonViCon(this.isEdit);
      await this.layDanhSachDonViConOption(null, 1);
      let arrayParentId = this.form.duongDan_ID_DonVi_Cha.split("/");
      for (let i = 0; i < arrayParentId.length; i++) {
        await this.layDanhSachDonViConOption(
          parseInt(arrayParentId[i]),
          1,
          true
        );
      }
    } else {
      this.layDanhSachDonViConOption(null);
      this.form.iD_DonVi_Cha = null;
    }
  },
  methods: {
    themDonVi() {
      this.$router.push(`${this.$route.path}?idDonViCha=${this.isEdit}`);
    },
    goEdit() {
      this.$router.push(`${this.$route.path}?id=${this.isEdit}`);
    },
    openEdit(item) {
      this.$router.push(`?id=${item.id}`);
    },
    openDelete(item) {
      this.donViDaChon = item;
      this.$bvModal
        .msgBoxConfirm(`Bạn có muốn xóa '${this.donViDaChon.tenDonVi}' ?`, {
          okTitle: "Xóa",
          cancelTitle: "Hủy",
          centered: true,
        })
        .then((confirm) => {
          if (confirm) {
            this.$store.dispatch("donVi/xoaDonVi", {
              data: { id: this.donViDaChon.id },
              onSuccess: this.onSuccessDelete,
            });
          }
        })
        .catch();
    },
    onSuccessDelete() {
      this.layDanhSachDonViCon(this.isEdit);
    },
    layDanhSachTheoDonViCha(id) {
      this.$store.dispatch("donVi/layDanhSachTheoDonViCha", {
        idDonViCha: id,
        soCap: 1,
      });
      this.idDaChon = id;
    },
    capNhatThuTuNhomChucVu() {
      let listUpdate = [];
      this.items.forEach(function (item, index) {
        listUpdate.push({ Id: item.id, ThuTu: index + 1 });
      });
      let payload = new FormData();
      payload.append("arrangeRequest", JSON.stringify(listUpdate));
      this.$store.dispatch("donVi/capNhatThuTu", {
        data: payload,
        // onSuccess: null
      });
    },
    changeCurrentTab(tab) {
      this.activeTab = tab;
    },
    treeselectClass(valid) {
      return {
        "treeselect-invalid": valid,
      };
    },
    loadOptionsDonVi({ action, parentNode, callback }) {
      if (action === LOAD_CHILDREN_OPTIONS) {
        this.layDanhSachDonViConOption(parentNode.id).then((data) => {
          parentNode.children = data;
          callback();
          this.$refs.chonCayDonVi.initialize(this.optionsDonVi);
        });
      }
    },
    normalizer(node) {
      return {
        id: node.id,
        label: node.tenDonVi,
        children: node.children || null,
      };
    },
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    layDanhSachDonViConOption(parentId = null, level = 1, isInsert = false) {
      return this.$store
        .dispatch("donVi/layDanhSachTheoDonViCha", {
          idDonViCha: parentId,
          soCap: level,
        })
        .then((response) => {
          if (!parentId) {
            this.optionsDonVi = response;
          } else {
            if (isInsert) {
              let getOption = this.optionsDonVi;
              getOption.forEach(function iter(a) {
                if (a.id == parentId) {
                  a.children = response;
                }
                Array.isArray(a.children) && a.children.forEach(iter);
              });

              this.optionsDonVi = getOption;
              this.reloadDonVI = !this.reloadDonVI;
            } else return response;
          }
        });
    },
    layDanhSachDonViCon(parentId = null) {
      return this.$store
        .dispatch("donVi/layDanhSachTheoDonViCha", {
          idDonViCha: parentId,
        })
        .then((response) => {
          this.listDonViCon = response;
        });
    },
    layCayDonViCha() {
      this.$store
        .dispatch("donVi/layDanhSachTheoDonViCha", {
          idDonViCha: this.form.iD_DonVi_Cha,
          soCap: 1,
        })
        .then((response) => {
          if (this.isEdit)
            this.$store.dispatch("donVi/layChiTietDonVi", {
              data: {
                id: this.form.iD_DonVi_Cha,
              },
              onSuccess: (dataResponse) => {
                this.optionsDonVi = [
                  {
                    id: this.form.iD_DonVi_Cha,
                    tenDonVi: dataResponse.tenDonVi,
                    children: response,
                  },
                ];
              },
            });
        });
    },
    layDanhSachChucVu() {
      this.$store.dispatch("chucVu/layDanhSachChucVu");
    },
    layChiTietDonVi() {
      this.$store.dispatch("donVi/layChiTietDonVi", {
        data: {
          id: this.isEdit,
        },
        onSuccess: this.onSuccess,
      });
    },
    onSuccess(data) {
      console.log(data);
      this.form = data;
    },
    async onSubmit() {
      const isValid = await this.$refs.obCanBo.validate();
      const $vm = this;
      let data = $vm.form;
      data.capDonVi = parseInt(data.capDonVi);
      data.thuTu = parseInt(data.thuTu);
      if (isValid) {
        this.isLoading = true;
        if (this.isEdit) {
          await this.$store.dispatch("donVi/suaDonVi", {
            data: data,
            onSuccess: this.backToDetail,
          });
          this.isLoading = false;
        } else {
          await this.$store.dispatch("donVi/themDonVi", {
            data: data,
            onSuccess: this.backToList,
          });
          this.isLoading = false;
        }
      }
    },
    format(value) {
      return moment(value).format("YYYY-MM-DD");
    },
    backToList() {
      this.$router.push({
        name: ROUTE_NAME.QUAN_LY_DANH_MUC.DON_VI.NAME,
      });
    },
    backToDetail() {
      this.$router.replace(
        `${ROUTE_NAME.QUAN_LY_DANH_MUC.NAME}/${ROUTE_NAME.QUAN_LY_DANH_MUC.DON_VI.TAO}?id=${this.form.id}&onlyview=true`,
        () => {
          this.$router.go(0);
        }
      );
    },
    upLoadFileToServer(value) {
      console.log(value);
    },
    openCreateChucVu() {
      this.$refs["modalCapNhatChucVu"].$refs.modalCapNhatChucVu.show();
    },
  },
  watch: {
    chiTietCanBo: {
      handler() {
        this.form = objectTrim(this.chiTietCanBo);
        this.form.ngaySinh = moment(this.form.ngaySinh).format("YYYY-MM-DD");
      },
    },
    listDonViCon: {
      handler(value) {
        this.items = value;
      },
    },
  },
};
</script>
